<template>
	<div>
		<div class="header-blank">
			<el-image style="width: 100%; height: 100px" :src="header_pic" fit="cover"></el-image>
		</div>

		<div class="header">
			<div class="header-top">
				<el-image style="width: 100%; height: 100px" :src="header_pic" fit="cover"></el-image>
				<div class="header-title flex">
					<div class="title">小树窝</div>
				</div>
			</div>
			<!-- <div class="header-menu-div">
				<el-menu :default-active="activeIndex2" class="el-menu-demo flex" mode="horizontal" @select="handleSelect"
					background-color="#000" text-color="#fff" active-text-color="#fff">
					<el-menu-item index="1" >网站首页</el-menu-item>
					<el-menu-item index="3" >明标会场</el-menu-item>
					<el-menu-item index="4" >暗标会场</el-menu-item>
					<el-menu-item index="5" >二手车直销</el-menu-item>
					<el-menu-item index="6" >个人中心</el-menu-item>
					<el-menu-item index="7">事故查询</el-menu-item>
					<el-menu-item index="8">物资拍卖</el-menu-item>
					<el-menu-item index="9">行业资讯</el-menu-item>
				</el-menu>
			</div> -->
		</div>

	</div>
</template>
<script>
	import header_pic from '@/assets/header.jpg'

	export default {
		props: ["nav"],
		data() {
			return {
				header_pic,

				statusBarHeight: 0,
				titleBarHeight: 0,
				flag: 1,
				cityName: "",
				searchVal: "",

				activeIndex: '1',
				activeIndex2: '1',
				
			}
		},
		created() {
			var that = this;

		},
		methods: {
			// 回到上一页
			back: function() {
				uni.navigateBack({
					delta: 1
				})
			},

			handleSelect(key, keyPath) {
				// console.log(key, keyPath);
				if(key == '1'){
					this.activeIndex2 = key;
					this.$router.push('/');
				} else {
					this.activeIndex2 = "";
					this.$router.push('/login');
				}
			},
			
			homePage(){
				this.$router.push('/');
			},
			
			loginPage(){
				this.$router.push('/login');
			},



		}
	}
</script>

<style scoped>
	.header {
		width: 100%;
		background-color: #000000;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 100;
		line-height: 0;
	}

	.header-blank {
		width: 100%;
		/* padding-bottom: 42px; */
		opacity: 0;
		line-height: 0;
	}

	.header-top {
		width: 100%;
		position: relative;
		top: 0;
		left: 0;
		z-index: 100;
		line-height: 0;
	}

	.header-title {
		width: 1250px;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		margin: 0 auto;
	}

	.header-title .title {
		color: #FFFFFF;
		font-weight: bold;
		font-size: 32px;
		margin-left: ;
	}
	
	.header-menu-div{
		width: 1250px;
		height: 100%;
		/* position: absolute;
		top: 0;
		left: 0;
		right: 0; */
		margin: 0 auto;
	}
	.el-menu-demo {
		border-bottom: none;
		justify-content: space-between;
	}
	.el-menu-demo .el-menu-item{
		flex: 1;
		height: 42px;
		line-height: 42px;
		text-align: center;
		font-size: 16px;
		font-weight: 700;
		border-bottom-color: #000 !important;
	}
	
	.el-menu-demo .is-active{
		background-color: #d82117 !important;
		border-bottom-color: #d82117 !important;
	}
</style>
